var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// db/GlobalSettings.ts
import { A } from "@adornis/base/env-info.js";
import { ID } from "@adornis/baseql/baseqlTypes.js";
import { Entity, Field } from "@adornis/baseql/decorators.js";
import { AdornisEntity } from "@adornis/baseql/entities/adornisEntity.js";
import { MongoEntity } from "@adornis/baseql/entities/mongoEntity.js";
import { baseqlMetaData } from "@adornis/baseql/metadata/metaDataStore.js";
import { registerSubscription } from "@adornis/baseql/metadata/register.js";
import { getRawCollection } from "@adornis/baseql/server/collections.js";
import { watchQuery } from "@adornis/baseql/server/watchQuery.js";
import { validate } from "@adornis/validation/decorators.js";
import { ValidationError } from "@adornis/validation/errors/ValidationError.js";
import { and } from "@adornis/validation/functions/and.js";
import { nonOptional } from "@adornis/validation/functions/nonOptional.js";
import { filter, map, tap } from "rxjs";
import { Base } from "./Base.js";
function splitSpacingString(fullString) {
  fullString = fullString ?? "";
  const numberMatch = fullString.match(/^\d+/);
  const numStr = numberMatch?.[0];
  const unitStr = fullString.slice(numStr?.length);
  return { number: numStr ? +numStr : null, unit: unitStr || null };
}
var validSpacingUnits = [
  "px",
  "cm",
  "mm",
  "in",
  "pt",
  "pc",
  "em",
  "ex",
  "ch",
  "rem",
  "vw",
  "vh",
  "vmin",
  "vmax",
  "%"
];
var BuildifyGlobalSettingBorderRadiusDefinition = class extends AdornisEntity {
};
BuildifyGlobalSettingBorderRadiusDefinition._class = "BuildifyGlobalSettingBorderRadiusDefinition";
__decorateClass([
  Field((type) => ID, { default: (v) => v ?? A.getGloballyUniqueID() })
], BuildifyGlobalSettingBorderRadiusDefinition.prototype, "_id", 2);
__decorateClass([
  validate(nonOptional()),
  Field((type) => String)
], BuildifyGlobalSettingBorderRadiusDefinition.prototype, "name", 2);
__decorateClass([
  validate(nonOptional()),
  Field((type) => String)
], BuildifyGlobalSettingBorderRadiusDefinition.prototype, "borderRadius", 2);
BuildifyGlobalSettingBorderRadiusDefinition = __decorateClass([
  Entity()
], BuildifyGlobalSettingBorderRadiusDefinition);
var BuildifyGlobalSettingBorderDefinition = class extends AdornisEntity {
};
BuildifyGlobalSettingBorderDefinition._class = "BuildifyGlobalSettingBorderDefinition";
__decorateClass([
  Field((type) => ID, { default: (v) => v ?? A.getGloballyUniqueID() })
], BuildifyGlobalSettingBorderDefinition.prototype, "_id", 2);
__decorateClass([
  validate(nonOptional()),
  Field((type) => String)
], BuildifyGlobalSettingBorderDefinition.prototype, "name", 2);
__decorateClass([
  validate(nonOptional()),
  Field((type) => String)
], BuildifyGlobalSettingBorderDefinition.prototype, "border", 2);
BuildifyGlobalSettingBorderDefinition = __decorateClass([
  Entity()
], BuildifyGlobalSettingBorderDefinition);
var BuildifyGlobalSettingSpacingDefinition = class extends AdornisEntity {
};
BuildifyGlobalSettingSpacingDefinition._class = "BuildifyGlobalSettingSpacingDefinition";
__decorateClass([
  Field((type) => ID, { default: (v) => v ?? A.getGloballyUniqueID() })
], BuildifyGlobalSettingSpacingDefinition.prototype, "_id", 2);
__decorateClass([
  validate(nonOptional()),
  Field((type) => String)
], BuildifyGlobalSettingSpacingDefinition.prototype, "name", 2);
__decorateClass([
  validate(
    and(nonOptional(), ({ value, key, target }) => {
      const parts = value.split(" ");
      for (const part of parts) {
        const spacingObj = splitSpacingString(part);
        if (spacingObj.number === null || isNaN(spacingObj.number))
          throw new ValidationError("Abstand-Zahl muss eine valide Zahl sein", { key, target });
        if (!spacingObj.unit || !validSpacingUnits.includes(spacingObj.unit))
          throw new ValidationError("Abstand-Einheit muss eine valide CSS L\xE4ngeneinheit sein", { key, target });
      }
    })
  ),
  Field((type) => String)
], BuildifyGlobalSettingSpacingDefinition.prototype, "spacing", 2);
BuildifyGlobalSettingSpacingDefinition = __decorateClass([
  Entity()
], BuildifyGlobalSettingSpacingDefinition);
var BuildifyGlobalSettings = class extends MongoEntity {
};
BuildifyGlobalSettings._class = "BuildifyGlobalSettings";
BuildifyGlobalSettings._collectionName = "buildify-global-settings";
__decorateClass([
  validate(nonOptional()),
  Field((type) => [String], { default: (v) => v ?? [] })
], BuildifyGlobalSettings.prototype, "colors", 2);
__decorateClass([
  validate(nonOptional()),
  Field((type) => [BuildifyGlobalSettingSpacingDefinition], { default: (v) => v ?? [] })
], BuildifyGlobalSettings.prototype, "spacings", 2);
__decorateClass([
  validate(nonOptional()),
  Field((type) => [BuildifyGlobalSettingBorderRadiusDefinition], { default: (v) => v ?? [] })
], BuildifyGlobalSettings.prototype, "borderRadius", 2);
__decorateClass([
  validate(nonOptional()),
  Field((type) => [BuildifyGlobalSettingBorderDefinition], { default: (v) => v ?? [] })
], BuildifyGlobalSettings.prototype, "border", 2);
__decorateClass([
  Field((type) => String)
], BuildifyGlobalSettings.prototype, "sectionWidth", 2);
__decorateClass([
  validate(nonOptional()),
  Field((type) => [BuildifyGlobalSettingSpacingDefinition], { default: (v) => v ?? [] })
], BuildifyGlobalSettings.prototype, "widths", 2);
__decorateClass([
  Field((type) => [BuildifyGlobalSettingBaseTemplate], { default: (v) => v ?? [] })
], BuildifyGlobalSettings.prototype, "baseTemplates", 2);
BuildifyGlobalSettings = __decorateClass([
  Entity()
], BuildifyGlobalSettings);
var subscribeBuildifyGlobalSettings = registerSubscription({
  operationName: "subscribeBuildifyGlobalSettings",
  resolve: (className = BuildifyGlobalSettings._class) => (gqlFields) => {
    const resolvedClass = baseqlMetaData.entities.resolveNode(className);
    const GlobalSettingsClass = resolvedClass.type();
    const checkValidClass = (settingsClass, iBecomeTyped) => {
      if (settingsClass.type() === BuildifyGlobalSettings)
        return true;
      const parent = settingsClass.parent;
      if (parent && checkValidClass(parent, iBecomeTyped))
        return true;
      return false;
    };
    if (!checkValidClass(resolvedClass, GlobalSettingsClass))
      throw new Error("you have to parse through a valid global settings class");
    const colName = GlobalSettingsClass._collectionName;
    return watchQuery(colName, { _class: GlobalSettingsClass._class }).pipe(
      map((settingsArr) => settingsArr[0]),
      tap(async (settings) => {
        if (settings)
          return;
        const col = await getRawCollection(colName);
        await col.updateOne(
          { _class: GlobalSettingsClass._class },
          { $setOnInsert: { ...new GlobalSettingsClass({}).toJSON(), _id: A.getGloballyUniqueID() } },
          { upsert: true }
        );
      }),
      filter(Boolean)
    );
  },
  type: () => BuildifyGlobalSettings,
  params: [{ name: "className", type: () => String }]
});
var BuildifyGlobalSettingBaseTemplate = class extends AdornisEntity {
};
BuildifyGlobalSettingBaseTemplate._class = "BuildifyGlobalSettingBaseTemplate";
__decorateClass([
  validate(nonOptional()),
  Field((type) => String, { default: (v) => v ?? A.getGloballyUniqueID() })
], BuildifyGlobalSettingBaseTemplate.prototype, "_id", 2);
__decorateClass([
  validate(nonOptional()),
  Field((type) => Base)
], BuildifyGlobalSettingBaseTemplate.prototype, "template", 2);
__decorateClass([
  validate(nonOptional()),
  Field((type) => String)
], BuildifyGlobalSettingBaseTemplate.prototype, "name", 2);
BuildifyGlobalSettingBaseTemplate = __decorateClass([
  Entity()
], BuildifyGlobalSettingBaseTemplate);
export {
  BuildifyGlobalSettingBaseTemplate,
  BuildifyGlobalSettingBorderDefinition,
  BuildifyGlobalSettingBorderRadiusDefinition,
  BuildifyGlobalSettingSpacingDefinition,
  BuildifyGlobalSettings,
  splitSpacingString,
  subscribeBuildifyGlobalSettings,
  validSpacingUnits
};
